import React,{useState} from "react";
import axios from "axios";
import { useLocation } from "wouter";
import "./UserDetails.css";

export default function UserDetails(){

  const url = new URLSearchParams(window.location.search);
  const email = url.get("email"),
        regid = url.get("regid"),
        mobile_prev = url.get("mobile");

  // NEW FIELDS
  const [name,setName] = useState("");
  const [branch,setBranch] = useState("");
  const [year,setYear] = useState("");
  const [session,setSession] = useState("");
  const [userType,setUserType] = useState("");
  const [gender,setGender] = useState("");   // ✅ ADDED

  // OLD FIELDS
  const [mobile,setMobile] = useState(mobile_prev || "");
  const [dob,setDob] = useState(""); 
  const [pass,setPass] = useState("");
  const [conf,setConf] = useState("");
  const [file,setFile] = useState(null);

  const [,setLocation] = useLocation(); 
  const [loading,setLoading] = useState(false);

  function handleMobile(e){
    const value = e.target.value.replace(/\D/g,"").slice(0,10);
    setMobile(value);
  }

  function toBase64(file){
    return new Promise((res,rej)=>{
      const r = new FileReader(); 
      r.onload = ()=>res(r.result.split(",")[1]);
      r.onerror = rej; 
      r.readAsDataURL(file);
    });
  }

  async function submit(){

    if(!name) return alert("Enter Full Name");
    if(!branch) return alert("Enter Branch");
    if(!year) return alert("Enter Year");
    if(!session) return alert("Enter Session");
    if(!userType) return alert("Select User Type");
    if(!gender) return alert("Select Gender");        // ✅ ADDED
    if(mobile.length !== 10) return alert("Enter valid 10-digit Mobile Number!");
    if(pass.length < 8) return alert("Password must be at least 8 characters long!");
    if(pass !== conf) return alert("Passwords do not match!");
    if(!dob) return alert("Select DOB");
    if(!file) return alert("Upload Profile Image");

    setLoading(true);

    const b64 = await toBase64(file);

    const res = await axios.post(
      "https://recstudentportal.com/ram/app/register_web.php",
      {
        regid,
        email,
        phone: mobile,
        name,
        branch,
        year,
        session,
        userType,
        gender,          // ✅ ADDED
        dob,
        password: pass,
        image: b64
      },
      { headers: { "Content-Type":"application/json" } }
    );

    if(res.data.status === 0 || res.data.status === "success"){
      alert("🎉 Account Created Successfully!");
      setLocation("/login");
    }else{
      alert(res.data.message || "Registration Error");
    }

    setLoading(false);
  }

  return(
    <div className="register-wrapper">
      <div id="regbg"></div>

      <div className="register-card">

        <div className="head">
          <div className="spanlogin">
            <span>PROFILE DETAILS</span>
          </div>
          <p>Final Step — Complete Your Profile</p>
        </div>

        <hr/>

        <input type="text" placeholder="Full Name" onChange={e=>setName(e.target.value)} />
        <input type="text" placeholder="Branch" onChange={e=>setBranch(e.target.value)} />
        <input type="number" placeholder="Year (1/2/3/4)" onChange={e=>setYear(e.target.value)} />
        <input type="text" placeholder="Session (2023-2027)" onChange={e=>setSession(e.target.value)} />

        <select onChange={e=>setUserType(e.target.value)}>
          <option value="">Select User Type</option>
          <option value="student">Student</option>
          <option value="professor">Professor</option>
          <option value="hod">HOD</option>
          <option value="management">Management</option>
        </select>

        {/* ✅ GENDER DROPDOWN — ADDED */}
        <select onChange={e=>setGender(e.target.value)}>
          <option value="">Select Gender</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
        </select>

        <input
          type="text"
          inputMode="numeric"
          placeholder="Mobile Number"
          value={mobile}
          onChange={handleMobile}
        />

        <input type="date" onChange={e=>setDob(e.target.value)} />

        <input
          type="password"
          placeholder="Password (at least 8 characters)"
          onChange={e=>setPass(e.target.value)}
        />

        <input
          type="password"
          placeholder="Confirm Password"
          onChange={e=>setConf(e.target.value)}
        />

        <input
          placeholder="Profile Picture"
          type="file"
          accept="image/*"
          onChange={e=>setFile(e.target.files[0])}
        />

        <button className="regBtn" onClick={submit} disabled={loading}>
          {loading ? "Creating..." : "Create Account"}
        </button>

      </div>
    </div>
  );
}
